import { render, staticRenderFns } from "./UiAlerts.vue?vue&type=template&id=e58f98ba"
import script from "./UiAlerts.vue?vue&type=script&lang=js"
export * from "./UiAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports